// ** React Imports
import React from "react";

// ** Utils & Helpers
import { round } from "utils/math";

// ** Styles
import {
	VolumeBarContainer,
	VolumeBarValue,
	VolumeBarValueInput,
} from "./styles";

//##################################

const VolumeBar = ({ volume, onChange, onFocus }) => {
	const volumePercent = `${round(volume * 100, 2)}%`;

	return (
		<VolumeBarContainer className="swiper-no-swiping">
			<VolumeBarValue value={volumePercent} />
			<VolumeBarValueInput
				min={0}
				max={1}
				step="any"
				value={volume}
				onChange={onChange}
				onFocus={onFocus}
			/>
		</VolumeBarContainer>
	);
};

export default VolumeBar;
